'use client'

import { ConfirmDialog } from '@macarongfactory/web-ui'
import { useEffect, useRef } from 'react'

import { MODOOCAR_CODE, useModoocarTracking } from '../_features/modoocar'

interface IRatingCompleteDialogProps {
  open: boolean
  score: number
  onClose: () => void
  onViewReviews: () => void
}

const RatingCompleteDialog = ({
  open,
  score,
  onClose,
  onViewReviews,
}: IRatingCompleteDialogProps) => {
  const { itemShow, itemClick } = useModoocarTracking()
  const shownRef = useRef(false)
  useEffect(() => {
    if (!open || shownRef.current) return
    shownRef.current = true
    itemShow(MODOOCAR_CODE.RATING_COMPLETE, 'dialog', '평가 완료', { score })
  }, [open, score, itemShow])

  const handleLater = () => {
    itemClick(MODOOCAR_CODE.RATING_COMPLETE, 'button', '나중에')
    onClose()
  }
  const handleViewReviews = () => {
    itemClick(MODOOCAR_CODE.RATING_COMPLETE, 'button', '리뷰 보기')
    onViewReviews()
  }

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      className='[&_section>div]:!pb-dimension-x4'
      top={
        <ConfirmDialog.Top.LeftAlignedHeader
          title='내 차 만족도 점수에 반영했어요'
          description='내 차 오너들의 다양한 리뷰도 확인해보세요.'
          className='break-keep'
        />
      }
      bottom={
        <ConfirmDialog.Bottom.BottomCTA.Horizontal
          subButton={
            <ConfirmDialog.Bottom.SubButton.SolidButton
              text='나중에'
              onClick={handleLater}
            />
          }
          mainButton={
            <ConfirmDialog.Bottom.MainButton.SolidButton
              text='리뷰 보기'
              onClick={handleViewReviews}
            />
          }
        />
      }
    />
  )
}

export default RatingCompleteDialog
